module.exports = __webpack_public_path__ + "static/media/AB-Fish_circle.39b53ea8.png";